@use 'src/globals/main';

pn-fieldset {
  display: inline-block;
}
pn-fieldset .pn-fieldset {
  border: 0;
  padding: 0;
  margin: 0;
  color: main.$gray900;
  display: flex;
  flex-direction: column;
  font-size: 1em;

  &-legend {
    float: left;
    font-weight: 500;
    line-height: 1.4;
    padding: 0;
  }

  &-helpertext {
    color: main.$gray700;
    margin: 0;
  }

  &-items {
    padding: 0.75em 0;
    display: flex;
    flex-direction: column;
    gap: 0.75em;
  }

  &-message-wrapper {
    display: flex;
    gap: 0.75em;
    color: main.$gray900;
    line-height: 1.4;
    font-weight: 400;
    &[hidden] {
      display: none;
    }
  }

  &-message {
    margin: 0;
  }

  &[data-error] {
    > .pn-fieldset-legend,
    > .pn-fieldset-helpertext,
    > .pn-fieldset-message-wrapper {
      color: main.$warning;

      > pn-icon .pn-icon-svg > path {
        fill: main.$warning;
      }
    }
  }

  &:disabled {
    > .pn-fieldset-legend,
    > .pn-fieldset-helpertext,
    > .pn-fieldset-message,
    > .pn-fieldset-message-wrapper {
      color: main.$gray900;

      > pn-icon .pn-icon-svg > path {
        fill: main.$gray900;
      }
    }
  }
}
